export const PRIVACY_POLICY = 'https://www.notchordering.com/company/privacy';
export const TERMS_OF_USE = 'https://www.notchordering.com/usageterms';
export const HELP_DESK = 'mailto:support@notch.financial';
export const LETS_TALK = 'https://www.notch.financial/company/lets-talk';
